import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import * as ContentActions from '../../../actions/content'
import { fetchDevice as fetchDeviceAction } from '../../../actions/stores'

import { channels as channelsProps, device as deviceProps } from '../../../types'
import { DeviceChannels as DeviceChannelsDOM } from '../../../components/Screens/Estate/Store'

class DeviceChannels extends Component {
    static propTypes = {
        attachChannelToDevice: PropTypes.func.isRequired,
        channels: PropTypes.arrayOf(PropTypes.shape(channelsProps)).isRequired,
        detachChannelToDevice: PropTypes.func.isRequired,
        device: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
        fetchChannels: PropTypes.func.isRequired,
        fetchDevice: PropTypes.func.isRequired,
        isOpen: PropTypes.bool,
        onClickCancel: PropTypes.func,
        selectedDevice: PropTypes.shape(deviceProps),
        openCloseConfirm: PropTypes.func,
        onOpenDeviceUpdateForm: PropTypes.func,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        device: null,
        isOpen: false,
        onClickCancel: () => null,
        selectedDevice: null,
        openCloseConfirm: () => null,
        onOpenDeviceUpdateForm: () => null,
    }

    constructor(props) {
        super(props)

        this.state = {
            selectedIndex: -1,
        }

        this.ref = React.createRef()

        this.onTextChange = this.onTextChange.bind(this)
        this.onRemoveChannel = this.onRemoveChannel.bind(this)
        this.onSelectChannel = this.onSelectChannel.bind(this)
    }

    componentDidUpdate(lastProps) {
        const { isOpen: wasOpen } = lastProps
        const { isOpen } = this.props

        this.checkSelectedChannel()

        if (isOpen && !wasOpen) {
            this.fetchChannels()
            this.fetchDevice()
        }
    }

    /**
     * Get device full data
     */
    get device() {
        const { selectedDevice } = this.props
        return selectedDevice
    }

    /**
     * Get device ID
     */
    get deviceID() {
        const { device } = this.props
        return device
    }

    /**
     * Get channels from current device
     */
    get channels() {
        const { device } = this
        const { channels = [] } = device || {}

        return channels
    }

    /**
     * Get all the channels availables for the suggestions input
     */
    get optionsChannels() {
        const { channels } = this.props
        const { device } = this
        const { channels: deviceChannels = [] } = device || {}
        const alreadyIncludedChannels = deviceChannels.reduce((out, { id }) => ({ ...out, [id]: true }), {})
        const formattedChannels = channels
            .filter(({ id }) => !alreadyIncludedChannels[id])
            .map(({ id, name }) => ({
                key: id,
                value: name,
            }))

        return formattedChannels
    }

    /**
     * Fetches a list of channels
     * @param {String} name name or partial name of the channel to look for
     */
    async fetchChannels(name) {
        const { fetchChannels } = this.props
        await fetchChannels(null, { name })
    }

    /**
     * Fetches selected device information
     */
    async fetchDevice() {
        const { device, fetchDevice } = this.props
        await fetchDevice(device)
    }

    /**
     * Callback when the chnannel remove button is clicked
     * @param {Number} index Selected channel index
     */
    async onRemoveChannel(index) {
        const { deviceID } = this

        if (!deviceID) {
            return null
        }

        const { channels } = this
        const { id: channelID } = channels[index] || {}

        if (!channelID) {
            return null
        }

        const { detachChannelToDevice } = this.props
        await detachChannelToDevice(channelID, deviceID)
    }

    /**
     * Callback when a channel is selected to be attached
     * @param {Number} channelID
     */
    async onSelectChannel(channelID) {
        const { deviceID } = this

        if (!deviceID) {
            return null
        }

        const { attachChannelToDevice } = this.props
        await attachChannelToDevice(channelID, deviceID)
    }

    /**
     * Look for channels suggestions
     * @param {String} value Total or partial channel name
     */
    onTextChange(value) {
        if (typeof value === 'string' && (value.length === 0 || value.length > 2)) {
            this.fetchChannels(value)
        }
    }

    checkSelectedChannel = (saveOnState = true) => {
        const { selectedIndex } = this.state
        const { device } = this
        const { channels = [] } = device || {}
        const { selected_channel } = device || {}

        const index = channels.findIndex((channel) => channel.slug === selected_channel)
        if (selectedIndex !== index && saveOnState) this.setState({ selectedIndex: index })
        else return index
    }

    openUpdateForm = () => {
        const { device } = this
        const { id } = device || {}
        const { onOpenDeviceUpdateForm, t } = this.props
        onOpenDeviceUpdateForm(
            id,
            () => null,
            t('UpdateSettingsConfirmHeader'),
            `${t('UpdateSettingsConfirmBody')} ${id} ${t('UpdateSettingsConfirmBodySecond')}?`
        )
    }

    onClickCancel = () => {
        const { onClickCancel, t, openCloseConfirm } = this.props
        const { device } = this
        const { channels = [] } = device || {}
        if (this.checkSelectedChannel(false) < 0 && channels.length > 0) {
            openCloseConfirm(
                this.openUpdateForm,
                t('Not selected channel'),
                t("The selected channel for the device doesn't match with any channel on the list. Do you want to update the device?")
            )
        }
        onClickCancel()
    }

    render() {
        const { isOpen } = this.props
        const { selectedIndex } = this.state

        return (
            <DeviceChannelsDOM
                deviceID={this.deviceID}
                channels={this.channels}
                isOpen={isOpen}
                onClickCancel={this.onClickCancel}
                onRemoveChannel={this.onRemoveChannel}
                onSelectChannel={this.onSelectChannel}
                onTextChange={this.onTextChange}
                options={this.optionsChannels}
                selectedIndex={selectedIndex}
            />
        )
    }
}

const mapStateToProps = ({ content: { channels }, stores: { selectedDevice, selectedStore } }) => ({
    channels,
    selectedDevice,
    selectedStore,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...ContentActions,
            fetchDevice: fetchDeviceAction,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DeviceChannels))
